/**
 * Top-level constants for the Voluntary Insurance pipeline module
 */

import type { PipelineTab, LeadsSubTab } from './shared/types';

// ─── Tab Configuration ────────────────────────────────────────

export const TAB_CONFIG: { key: PipelineTab; labelKey: string }[] = [
  { key: 'leads', labelKey: 'tabLeads' },
  { key: 'all_policies', labelKey: 'tabAllPolicies' },
  { key: 'payment', labelKey: 'tabPayment' },
  { key: 'sale_reporting', labelKey: 'tabSaleReporting' },
  { key: 'issuance', labelKey: 'tabIssuance' },
  { key: 'delivery', labelKey: 'tabDelivery' },
  { key: 'completed', labelKey: 'tabCompleted' },
  { key: 'cancelled', labelKey: 'tabCancelled' },
];

export const LEADS_SUB_TAB_CONFIG: { key: LeadsSubTab; labelKey: string }[] = [
  { key: 'new_leads', labelKey: 'subTabNewLeads' },
  { key: 'renewals', labelKey: 'subTabRenewals' },
];

// ─── URL Param Mapping ────────────────────────────────────────

export const TAB_TO_URL: Record<PipelineTab, string> = {
  leads: 'leads',
  all_policies: 'all-policies',
  payment: 'payment',
  sale_reporting: 'sale-reporting',
  issuance: 'issuance',
  delivery: 'delivery',
  completed: 'completed',
  cancelled: 'cancelled',
};

export const URL_TO_TAB: Record<string, PipelineTab> = Object.fromEntries(
  Object.entries(TAB_TO_URL).map(([tab, url]) => [url, tab as PipelineTab]),
) as Record<string, PipelineTab>;

export const SUB_TAB_TO_URL: Record<LeadsSubTab, string> = {
  new_leads: 'new-leads',
  renewals: 'renewals',
};

export const URL_TO_SUB_TAB: Record<string, LeadsSubTab> = Object.fromEntries(
  Object.entries(SUB_TAB_TO_URL).map(([tab, url]) => [url, tab as LeadsSubTab]),
) as Record<string, LeadsSubTab>;

// ─── Default Date Range ───────────────────────────────────────

export const DEFAULT_DATE_RANGE_MONTHS = 3;
export const MAX_DATE_RANGE_MONTHS = 13;
